import React from 'react';
import { inject } from "mobx-react";
import { transform } from 'lodash';
import autobind from 'autobind-decorator';

@inject('albumsStore')
export default class LinerNotes extends React.Component {
    render () {
        const { album, opened, onCloseClick } = this.props;

        if(opened) {
            return (
                <div className="fullsize">
                    <div className="row margin-bottom-2" style={{fontSize: '1.3rem', fontWeight: 'bold', justifyContent:'space-between'}}>
                        <div>Liner Notes</div>
                        <div>
                            <div className="row align-right margin-right-1" onClick={onCloseClick} style={{
                                fontSize: '1.1rem', 
                                fontWeight: "bold", 
                                color:'#9a53bf',
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                                height: '5%'
                            }}>
                            CLOSE
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{height: '75%'}}>
                        <p dangerouslySetInnerHTML={{__html: album.linerNotes}}></p>
                    </div>
                    
                </div>
            )
        }
        return (
            <div className="row artist-name-banner readmore small">
                <p className="liner-notes" dangerouslySetInnerHTML={{__html: album.linerNotes}}></p>
                <p style={{fontWeight: 'bold', color: '#9a53bf', marginTop: '0.5vh'}}>
                    ...Read More
                </p>
            </div>
        )
    }

   
}